'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import FullscreenOverlay from '@/src/components/features/property/ui/FullscreenOverlay';
import { useDetailPanelSafe } from '@/src/components/features/property/ui/DetailPanel';
import { RatingsDisclaimer } from './RatingsDisclaimer';
import { disclaimerTrigger } from './nearbySchoolsModule.styles';

const DisclaimerPanel = () => <RatingsDisclaimer />;

export const DisclaimerTrigger = () => {
  const t = useTranslations('hdp');
  const detailPanel = useDetailPanelSafe();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (detailPanel && !detailPanel.isMobile) {
    return (
      <button
        type="button"
        className={disclaimerTrigger}
        onClick={() => detailPanel.openPanel('school-ratings-disclaimer', DisclaimerPanel, { stacked: true })}
      >
        {t('learnMore')}
      </button>
    );
  }

  return (
    <FullscreenOverlay.Root open={mobileOpen} onOpenChange={setMobileOpen}>
      <FullscreenOverlay.Trigger asChild>
        <button type="button" className={disclaimerTrigger}>
          {t('learnMore')}
        </button>
      </FullscreenOverlay.Trigger>
      <FullscreenOverlay.Portal>
        <FullscreenOverlay.Backdrop>
          <FullscreenOverlay.Content>
            <FullscreenOverlay.Header title={t('schoolRatingsAboutTitle')} />
            <FullscreenOverlay.Body>
              <RatingsDisclaimer />
            </FullscreenOverlay.Body>
          </FullscreenOverlay.Content>
        </FullscreenOverlay.Backdrop>
      </FullscreenOverlay.Portal>
    </FullscreenOverlay.Root>
  );
};
